/**
 * @name rotate-cw-fading-clock
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgM2E5Ljc1IDkuNzUgMCAwIDEgNi43NCAyLjc0IiAvPgogIDxwYXRoIGQ9Ik0xOC43NCA1Ljc0IDIxIDgiIC8+CiAgPHBhdGggZD0iTTIxIDhWMyIgLz4KICA8cGF0aCBkPSJNNy41IDE5Ljc5NGMtNi0zLjQ2NC02LTEyLjEyNCAwLTE1LjU4OCIgLz4KICA8cGF0aCBkPSJNNy41IDQuMjA2QTkgOSAwIDAgMSAxMiAzIiAvPgogIDxwYXRoIGQ9Ik0xMiA3djVsNCAyIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMC43NzVBOSA5IDAgMCAxIDEyIDIxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxNy42NTZhOSA5IDAgMCAxLTEuNSAxLjQ1NiIgLz4KICA8cGF0aCBkPSJNMjEgMTJhOSA5IDAgMCAxLS4yMjggMiIgLz4KICA8cGF0aCBkPSJNMjEgOGgtNSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/rotate-cw-fading-clock
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const RotateCwFadingClock: string = `
<svg
  class="lucide lucide-rotate-cw-fading-clock"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M12 3a9.75 9.75 0 0 1 6.74 2.74" />
  <path d="M18.74 5.74 21 8" />
  <path d="M21 8V3" />
  <path d="M7.5 19.794c-6-3.464-6-12.124 0-15.588" />
  <path d="M7.5 4.206A9 9 0 0 1 12 3" />
  <path d="M12 7v5l4 2" />
  <path d="M14 20.775A9 9 0 0 1 12 21" />
  <path d="M19 17.656a9 9 0 0 1-1.5 1.456" />
  <path d="M21 12a9 9 0 0 1-.228 2" />
  <path d="M21 8h-5" />
</svg>
`;

export default RotateCwFadingClock;
